import React, {Dispatch, FC, Fragment, SetStateAction, useState} from "react";
import cls from "../CustomSelect/customSelect.module.scss";
import {CloseSvg, DropDownArrow} from "../../../svg";
import useOutside from "../../../hooks/useOutside";
import {optionItemType} from "../../../types/homePageTypes";
import {handleChangeOutsideForMulti} from "../../../components/ForCWV/InnerPageProduct/helpers";
interface ICustomSelect {
    selectArray: Array<optionItemType>;
    setOptionQuantity: Dispatch<SetStateAction<optionItemType[]>>
    optionQuantity: Array<optionItemType>
}

const CustomMultiSelect: FC<ICustomSelect> = (
    {
        selectArray,
        setOptionQuantity,
        optionQuantity
    }
) => {
    const defaultValueExist = selectArray?.find((item) => !!item.is_default)
        || {name: "Select Option", id: 0, is_default: 1, bundleOptionId: 1, productQty: 1, optionDefaultQty: 1, price: 0}
    const [open, setOpen] = useState<boolean>(false);
    const [selectVal, setSelectVal] = useState<Array<optionItemType>>([defaultValueExist])
    const {optionRef} = useOutside({setOpen})

    const handleOptionClick = (
        value: optionItemType,
        state: Array<optionItemType>,
        setState: Dispatch<SetStateAction<optionItemType[]>>
    ) => {
        const findThatItem: number = state.findIndex((item) => item.id === value.id);
        if (findThatItem === -1) {
            setState((prevState) => [...prevState, value])
        } else {
            setState((prevState) => prevState.filter((_, index: number) => index !== findThatItem))
        }
    }

    const handleRemoveClick = (
        e: React.MouseEvent<HTMLParagraphElement, MouseEvent>,
        value: optionItemType,
        setState: Dispatch<SetStateAction<optionItemType[]>>
    ) => {
        e.stopPropagation();
        setState((prevState) => prevState.filter((item) => item.id !== value.id))
    }


    return (
        <div className={cls.main} ref={optionRef}>
            <div className={cls.select} onClick={() => setOpen((prevState) => !prevState)}>
                {defaultValueExist.name === "Select Option" || selectVal.length === 0 ? (
                    <p>Select Option</p>
                ) : (
                    <div className={cls.multiBoxMain}>
                        {selectVal.map(multiItem => (
                            <div
                                className={cls.multiItemBox}
                                onClick={(e) => e.stopPropagation()}
                                key={multiItem.id as number}
                            >
                                <p>{multiItem.name}</p>
                                <p style={{marginLeft: "5px"}}
                                    onClick={(e) => {
                                    handleRemoveClick(e, multiItem, setSelectVal)
                                    handleChangeOutsideForMulti({target: {value: JSON.stringify(multiItem), id: multiItem.id as number}}, optionQuantity, setOptionQuantity)
                                }}><CloseSvg/></p>
                            </div>
                        ))}
                    </div>
                )}
                <DropDownArrow className={`${open ? cls.rotT_fms : ""}`}/>
            </div>
            {open ? (
                <div className={cls.optionBox}>
                    {selectArray?.map((elem) => {
                        const existThisValue: boolean = !!selectVal
                            .find(selectedItem => selectedItem.id === elem.id)
                        return (
                            <div
                                key={elem.id as number}
                                className={`${cls.select} ${cls.eachOption} ${existThisValue ? cls.grayBox : ""}`}
                                onClick={() => {
                                    handleOptionClick(elem, selectVal, setSelectVal);
                                    handleChangeOutsideForMulti({target: {value: JSON.stringify(elem), id: elem.id as number}}, optionQuantity, setOptionQuantity)
                                }}
                            >
                                {elem.name}
                            </div>
                        )
                    })}
                </div>
            ) : <Fragment/>}
        </div>
    )
};

export default CustomMultiSelect;
